<template>
  <div id="app">
    <div id="nav">
      <ul>
        <li>
          <router-link to="/">{{ title }}</router-link>
        </li>
        <li><router-link to="/graph">Graph</router-link></li>
      
        <li>
          <a
            href="https://status.scathachbot.xyz/"
            style="text-decoration: none"
            >Status</a
          >
        </li>
        <li>
          <a
            href="https://scathachbot.xyz/"
            style="text-decoration: none"
            >Index</a
          >
        </li>
      </ul>
    </div>

    <div v-if="switchTheme" id="mybutton">
      <button type="button" @click="darkThemeSwitch" class="switch">
        Oh, Snap!
      </button>
    </div>
    <router-view />
    <Footer></Footer>
  </div>
</template>

<script>
import themeChanger from "./switch.js";
import Footer from "./components/Footer";
import { switchTheme } from "../config";

export default {
  name: "app",
  data() {
    return {
      switchTheme: switchTheme,
      themeChanger: null,
      loading: false,
      all_users: null,
      title: "Scathach's data visualizations",
      sca: null,
      is_dark: false,
    };
  },
  components: {
    //PageLoader,
    Footer,
  },
  methods: {
    darkThemeSwitch() {
      this.themeChanger._darkThemeSwitch();
   
    },
  },
  created() {
    this.themeChanger = new themeChanger();
    
    // eslint-disable-next-line no-undef
    Chart.defaults.global.defaultFontColor = "#7393B3";
    // set font stroke
    // eslint-disable-next-line no-undef
    Chart.defaults.global.defaultFontStyle = "bold";
    // eslint-disable-next-line no-undef
    Chart.defaults.scale.gridLines.color = "rgba(135, 207, 235, 0.278)";
    
    // eslint-disable-next-line no-undef
    Chart.defaults.global.tooltips.callbacks.label = function (tooltipItem, data) {
      let value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
      if (value >= 1000) {
        let formattedValue = (value / 1000).toFixed(1);
        if (formattedValue % 1 === 0) {
          // If the decimal part is 0, remove it
          formattedValue = formattedValue.split(".")[0];
        }
        value = `${formattedValue}K`;
      }
      return value;
    };

  
  },
};
</script>

<style>
body {
  transition: all 0.5s ease-out;
}
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  
  
}

.column {
  border: 1px solid rgb(241, 216, 73);
  border-radius: 10px;
  margin: 10px;
}


#nav {
  padding: 30px;
  height: 90px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;

}

#nav a.router-link-exact-active {
  color: #42b983;
  text-decoration: none;
}

#nav ul {
  list-style-type: none;
  padding: 0;
}

#nav ul li {
  display: inline-block;
  margin: 0 10px;
}

h1 {
  font-size: 1.75em;
}

h2 {
  line-height: 2.5em;
  font-size: 1.25em;
}

.grid-wrapper {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 10px;
}

#btndisclaimer {
  position: fixed;
  right: 0;
  bottom: 0;
}

.switch {
  background-color: #31b0d5;
  color: white;
  padding: 10px 20px;
  border-radius: 4px;
  font-size: 16px;
  padding: 6px 10px;
  border-color: #46b8da;
}

#mybutton {
  position: fixed;
  bottom: 20px;
  right: 10px;
  z-index: 9999; /* Set a higher z-index value */
}

</style>
